import { useViewport } from '@lno/core/hooks'
import clsx from 'clsx'
import womanHoldingPhoneImage from '../../../images/desenrola/northEast/woman_holding_phone.png'
import womanHoldingPhoneWebpImage from '../../../images/desenrola/northEast/woman_holding_phone.webp'
import womanHoldingPhoneImage2x from '../../../images/desenrola/northEast/woman_holding_phone@2x.png'
import womanHoldingPhoneWebpImage2x from '../../../images/desenrola/northEast/woman_holding_phone@2x.webp'
import { styles } from '../styles'
const jsxScope = `jsx-${styles.__hash}`

export const DesenrolaNorthEastImage = () => {
  const { isMobile } = useViewport()
  return (
    <div className={clsx(jsxScope, 'desenrola-north-east-section__img')}>
      <picture>
        <source
          srcSet={`${womanHoldingPhoneWebpImage} 1x, ${womanHoldingPhoneWebpImage2x} 2x`}
          type="image/webp"
        />
        <img
          src={womanHoldingPhoneImage}
          srcSet={`${womanHoldingPhoneImage} 1x, ${womanHoldingPhoneImage2x} 2x`}
          width={isMobile ? 151 : 302}
          height={isMobile ? 190 : 380}
          alt=""
        />
      </picture>
    </div>
  )
}
